import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';

const AxiosError: React.FC = () => {
  const error = useRouteError() as { status?: number };
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100" data-testid="axios-error-page">
      <div className="text-center p-8 bg-white rounded-lg shadow-md" data-testid="axios-error-content">
        <h1 className="text-4xl font-bold text-red-600 mb-4" data-testid="axios-error-title">{t('error.oops')}</h1>
        <p className="text-xl text-gray-700 mb-6" data-testid="axios-error-message">
          {error?.status === 404
            ? t('error.pageNotFound')
            : t('error.somethingWentWrong')}
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          data-testid="axios-error-home-link"
        >
          {t('common.backToHome')}
        </Link>
      </div>
    </div>
  );
};

export default AxiosError;
